module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2ccece2ca30002d265c673e1445b59c2.png";